import { render, staticRenderFns } from "./BoardSubsectionShow.vue?vue&type=template&id=84fe8cea&scoped=true&"
import script from "./BoardSubsectionShow.vue?vue&type=script&lang=ts&"
export * from "./BoardSubsectionShow.vue?vue&type=script&lang=ts&"
import style0 from "./BoardSubsectionShow.vue?vue&type=style&index=0&id=84fe8cea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fe8cea",
  null
  
)

export default component.exports